/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_XY_LIVE", "566")
  

// 接口文档



export interface API77114Req {
  
  /** sessionCode ,String */
  sessionCodes: string[];
};



export type API77114Res = {};


// 接口函数 77114 删除会话

export interface IUsePostAPI77114Return {
  /** 删除会话: 接口请求状态 */
  isAPI77114Loading: boolean;
  /** 删除会话: 接口请求返回数据 */
  dataAPI77114: API77114Res;
  /**  删除会话: 接口数据请求方法 */
  fetchAPI77114Data: (inputs: API77114Req, config?: YWRequestConfig) => Promise<API77114Res>;
  /** 删除会话: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77114 = ():IUsePostAPI77114Return => {
  let isMount = true;
  const [isAPI77114Loading, setIsAPI77114Loading] = useState(false);
  const [dataAPI77114, setDataAPI77114] = useState<API77114Res>({} as API77114Res);
  const requestUrl = `${basePath}/yoaichat-admin/chat/remove/session`;

  const fetchAPI77114Data = async (inputs: API77114Req, config?: YWRequestConfig): Promise<API77114Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77114Req>) || {}) as API77114Req;
    
  
    if ( isMount ) {
      setIsAPI77114Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77114Res>(`${basePath}/yoaichat-admin/chat/remove/session`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77114(res || {} as API77114Res);
        setIsAPI77114Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77114Loading(false);
      }
      return false as unknown as API77114Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77114Loading,
    dataAPI77114,
    fetchAPI77114Data,
    requestUrl,
  }
}

